module.exports = require('./datahandler.js');


//////////////////
// WEBPACK FOOTER
// ../~/espn-fitt/es5/fitt-datahandler/index.js
// module id = 837
// module chunks = 0